import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from 'cccisd-nivo/bar';

const RespondentTotalChart = props => {
    const { data, markers } = props;

    const longestLabel = Math.max(
        ...data.map(o => {
            return o.label.length;
        })
    );

    return (
        <div style={{ width: '770px', height: `${600 + 6.5 * longestLabel}px` }}>
            <ResponsiveBar
                indexBy="label"
                groupMode="grouped"
                maxValue={100}
                labelFormat={d => <tspan y={-8}>{d}</tspan>}
                labelSkipWidth={0}
                labelSkipHeight={1}
                keys={['mean']}
                theme={{ fontSize: 16 }}
                axisBottom={{ tickRotation: 45 }}
                data={data}
                margin={{ top: 15, right: 150, bottom: 6.5 * longestLabel, left: 50 }}
                markers={markers}
            />
        </div>
    );
};

RespondentTotalChart.propTypes = {
    data: PropTypes.object,
    markers: PropTypes.object,
};

export default RespondentTotalChart;
